import { AffiliationPartnerData } from './../affiliation-partner.model';
import { FirestoreTimestampTimeAdapterService } from './../firestore-timestamp-time-adapter.service';
import { TransportationReservationRoute } from './../itineray.model';
import { Input } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { TransportationReservation } from '../itineray.model';
import { MatChipInputEvent } from '@angular/material/chips';
import { v4 as uuid } from "uuid";

@Component({
  selector: 'app-itinerary-reservations-transportation-form',
  templateUrl: './itinerary-reservations-transportation-form.component.html',
  styleUrls: ['./itinerary-reservations-transportation-form.component.css']
})
export class ItineraryReservationsTransportationFormComponent implements OnInit {

  @Input()
  transportation: TransportationReservation;

  @Input()
  transportationId: string;

  @Input()
  npax: number;

  @Input()
  disabled: boolean;

  @Input()
  detailFormFieldLabel: string = "dettaglio";

  @Input()
  stopsFormFieldLabel: string = "Tappe";

  @Input()
  showCodeFormField: boolean = true;

  private backupRoute: TransportationReservationRoute;

  constructor(public firestoreTimestampTimeAdapterService: FirestoreTimestampTimeAdapterService) { }

  affiliationPartnerData: AffiliationPartnerData[] = AffiliationPartnerData.values();

  ngOnInit() {
  }

  onARChange($event, transportation) {
    if (transportation.routes.length === 2) {
      this.backupRoute = transportation.routes.splice(1, 1)[0];
    } else {
      transportation.routes.push(this.backupRoute || {
        id: uuid(),
        title: "",
        company: "",
        code: "",
        from: "",
        fromDetail: "",
        fromCode: "",
        to: "",
        toDetail: "",
        toCode: "",
        start: null,
        end: null,
        stops: null,
        duration: {
          hours: null,
          minutes: null
        }
      })
    }
  }

  addStop(route: TransportationReservationRoute, event: MatChipInputEvent) {
    const input = event.input;
    const value = event.value;

    if ((value || '').trim()) {
      if (!route.stops) route.stops = [];
      route.stops.push(value.trim());
    }

    // Reset the input value
    if (input) {
      input.value = '';
    }
  }

  removeStop(route: TransportationReservationRoute, stop) {
    const idx = route.stops.indexOf(stop);
    if (idx >= 0) {
      route.stops.splice(idx, 1);
    }
    if (route.stops.length == 0) route.stops = null;
  }

}
